import {useSelector} from 'react-redux';
import {useFlag} from 'react-unleash-flags';
import useHasProperties from './use-has-properties';
import authenticatedRoutes from '../routes/authenticated.routes';
import {FEATURE_FLAG_TENANT_SELF_CHECK} from '../utils/constants/feature';
import {flagAllowsUserId} from '../utils/helpers/feature';

function useAuthenticatedRoutes() {
  const selfCheckFlag = useFlag(FEATURE_FLAG_TENANT_SELF_CHECK);
  const auth = useSelector(state => state.auth);
  const {profile = {}} = useSelector(state => state.tenant);

  const {hasProperties, isLoading} = useHasProperties();

  return {
    loading: isLoading,
    routes: authenticatedRoutes({
      ...auth,
      canAccessSelfCheck: flagAllowsUserId(selfCheckFlag, profile.email),
      hasProperties,
    }),
  };
}

export default useAuthenticatedRoutes;
